import { FEEDBACK_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const FeedbackService = {
  getAll: (params: any) => requests.get(`${FEEDBACK_URL}`, params),
  getById: (id: number) => requests.get(`${FEEDBACK_URL}/${id}`),
  resolve: (id: number) => requests.patch(`${FEEDBACK_URL}/${id}/resolve`),
  unresolve: (id: number) => requests.patch(`${FEEDBACK_URL}/${id}/unresolve`),
  reply: (id: number, body: { reply: string }) =>
    requests.post(`${FEEDBACK_URL}/${id}/reply`, body),
};
